module.exports = __webpack_public_path__ + "static/media/mercedes_03.0ca88c55.png";